export const AGENT_ANALYTICS_SHELL_STYLE = {
  backgroundColor: "#3b3835",
  borderColor: "rgba(212, 175, 55, 0.16)",
  boxShadow: "0 24px 80px rgba(0, 0, 0, 0.24)",
};

export const AGENT_ANALYTICS_SOFT_STYLE = {
  backgroundColor: "#312e2b",
  borderColor: "rgba(212, 175, 55, 0.12)",
  boxShadow: "0 18px 42px rgba(0, 0, 0, 0.18)",
};

export const AGENT_ANALYTICS_SOFT_ELEVATED_STYLE = {
  backgroundColor: "#2a2724",
  borderColor: "rgba(212, 175, 55, 0.1)",
  boxShadow: "0 18px 42px rgba(0, 0, 0, 0.16)",
};